module.exports = __webpack_public_path__ + "static/media/Portugal.30f27821.png";